import { c as _c } from "react/compiler-runtime";
import { AspectRatio, Box, Button, Heading, Text, VStack } from '@chakra-ui/react';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import Link from 'next/link';
import React from 'react';
import { LuArrowRight } from 'react-icons/lu';
export type HomePathCardProps = {
  href: string;
  title: string;
  description: string;
  ctaLabel: string;
  proofValue: string;
  proofLabel: string;
  illustration: React.ReactNode;
};

/**
 * Clickable product-path card for the home hero: illustration, copy, CTA chip, and a proof line.
 */
export const HomePathCard: React.FC<HomePathCardProps> = t0 => {
  const $ = _c(32);
  const {
    href,
    title,
    description,
    ctaLabel,
    illustration
  } = t0;
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t1;
  if ($[0] !== getBreakpointValue) {
    t1 = getBreakpointValue([3, 4, 4]);
    $[0] = getBreakpointValue;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cardPaddingX = t1;
  let t2;
  if ($[2] !== getBreakpointValue) {
    t2 = getBreakpointValue([3, 4, 4]);
    $[2] = getBreakpointValue;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const cardPaddingTop = t2;
  let t3;
  if ($[4] !== getBreakpointValue) {
    t3 = getBreakpointValue([4, 4, 5]);
    $[4] = getBreakpointValue;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const cardPaddingBottom = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      display: "flex",
      flex: 1,
      minHeight: 0,
      textDecoration: "none"
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      borderColor: "orange.400",
      transform: "translateY(-4px)",
      "& [data-part=cta]": {
        bg: "orange.500"
      }
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      "& svg": {
        display: "block",
        width: "100%",
        height: "100%"
      }
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== illustration) {
    t7 = <AspectRatio ratio={1.7777777777777777} width="full"><Box alignItems="center" bgImage="linear-gradient(135deg, #3a3b63, #20223f)" display="flex" justifyContent="center" overflow="hidden" css={t6}>{illustration}</Box></AspectRatio>;
    $[9] = illustration;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = ["xl", "xl", "2xl"];
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== title) {
    t9 = <Heading as="h3" fontSize={t8} fontWeight="extrabold" letterSpacing="-0.04em" lineHeight="1.1">{title}</Heading>;
    $[12] = title;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== description) {
    t10 = <Text color="fg.muted" flex={1} fontSize="sm" lineHeight="1.3">{description}</Text>;
    $[14] = description;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <LuArrowRight />;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== ctaLabel) {
    t12 = <Button as="span" data-part="cta" marginTop={4} pointerEvents="none" size="md" variant="cta" width="full">{ctaLabel}{t11}</Button>;
    $[17] = ctaLabel;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== cardPaddingBottom || $[20] !== cardPaddingTop || $[21] !== cardPaddingX || $[22] !== t10 || $[23] !== t12 || $[24] !== t9) {
    t13 = <VStack align="stretch" flex={1} gap={2} paddingBottom={cardPaddingBottom} paddingTop={cardPaddingTop} paddingX={cardPaddingX} textAlign="center">{t9}{t10}{t12}</VStack>;
    $[19] = cardPaddingBottom;
    $[20] = cardPaddingTop;
    $[21] = cardPaddingX;
    $[22] = t10;
    $[23] = t12;
    $[24] = t9;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13 || $[27] !== t7) {
    t14 = <VStack align="stretch" bg="bg.subtle" borderColor="border.emphasized" borderRadius="2xl" borderWidth="1px" boxShadow="0 20px 50px rgba(0, 0, 0, 0.45)" color="fg" flex={1} gap={0} overflow="hidden" transition="border-color 0.15s ease, transform 0.15s ease" _hover={t5}>{t7}{t13}</VStack>;
    $[26] = t13;
    $[27] = t7;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== href || $[30] !== t14) {
    t15 = <VStack align="stretch" gap={3} height="full" minWidth={0}><Link href={href} style={t4}>{t14}</Link></VStack>;
    $[29] = href;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  return t15;
};